exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-cobrowsing-plugin,#asseco-cobrowsing .asseco-floaty-btn{background-color:#fbc02d}#asseco-cobrowsing-plugin.is-active,#asseco-cobrowsing.is-active{animation:cobrowsing-blink 1s infinite}.agentPointer{position:absolute;z-index:50300;top:-1000px}.agentPointer span{position:relative;background-color:#b0222c;color:#fff;border-radius:5px;box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);padding:8px;top:15px}@keyframes cobrowsing-blink{0%{opacity:1}to{opacity:0}}", ""]);

// exports
